export enum PlanCapability {
  ORDERS_MODULE = 'ORDERS_MODULE',
  TABLE_RESERVATIONS_MODULE = 'TABLE_RESERVATIONS_MODULE',
  REPORTS_MODULE = 'REPORTS_MODULE',
}
